export const TODO_STATUSES = {
  COMPLETED: 'Completed',
  UPLOADED: 'Uploaded',
  NOT_STARTED: 'Not Started',
  IN_PROCESS: 'In Process',
  NOT_APPLICABLE: 'Not Applicable',
};
